module.exports = "/images/barril.svg?9d91c782d5796c7fca607b0fc4b40706";